import { render, staticRenderFns } from "./DialogConfirmSuccess.vue?vue&type=template&id=2d2958e2&scoped=true&lang=pug&"
import script from "./DialogConfirmSuccess.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmSuccess.vue?vue&type=style&index=0&id=2d2958e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2958e2",
  null
  
)

export default component.exports